module.exports = __webpack_public_path__ + "static/media/wave-bottom-white.721019f1.svg";